import AbsModule from "../common/AbsModule";
import PurpleUserInfo from "./PurpleUserInfo";
import SessionCheck from "../common/SesionCheck";
import PurpleUrl from "./PurpleUrl";

class PurpleBottomNav extends AbsModule {
    constructor(config) {
        super(config);
        
        this.purpleUserInfo = new PurpleUserInfo(config);
        
        // cnb 생성 시 및 15분 간격으로 인증 확인 API 호출
        new SessionCheck({
          goErrorPage: PurpleUrl.goErrorPage
        });
    }

    startSetting() {
        this.purpleUserInfo.startSetting({
            parentType: PurpleUserInfo.PARENT_TYPE_BOTTOM_NAV,
            parent: document.querySelector('.ncc-purple-bottom-nav')
        });
    }

    makeMarkup() {
        return `<div class="ncc-purple-bottom-nav">
            ${this.purpleUserInfo.markUp}
        </div>`;
    }
}

export default PurpleBottomNav;